var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-content',[_c('base-header',[_vm._v("Logged Out")]),_c('p',[_vm._v("\n    You've been logged out.\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }